import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
  path,
  mergeDeepLeft,
  clone,
} from 'ramda';
import Breadcrumbs from '../../common/Breadcrumbs';
import Input from '../../common/Input';
import DynamicFormList from '../../common/DynamicFormList';
import '../../css/forms/default-forms.css';
import {
  basic as fields,
  contacts,
} from './fields';
import { processFields } from '../../utils/prePost';
import { validateFields } from '../../utils/validate';
import { updateVendor, getVendor } from '../../api/vendors';
import { linkDataToFields } from '../../utils/fields';
import hasAccess from "../../helpers/permissionChecker";

export class VendorEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: clone(fields),
      remove_vendor_contact_ids: [],
    };
    this.submit = this.submit.bind(this);
    this.cancel = this.cancel.bind(this);
    this.changeFormValue = this.changeFormValue.bind(this);
    this.fetchDataRouteById = this.fetchDataRouteById.bind(this);
  }

  fetchDataRouteById() {
    const id = path(['match', 'params', 'id'], this.props);
    this.props.getDataById(id);
  }

  componentDidMount() {
    this.fetchDataRouteById();
  }

  componentDidUpdate(prevProps, prevState) {
    const currentVendor = path(['vendors', 'currentVendor'], this.props);

    if (currentVendor && currentVendor !== prevProps.vendors.currentVendor) {
      const linkFields = {
        contacts: [],
        name: this.state.fields.name,
      };
      const extraFields = { contacts: { ...clone(contacts) } };

      const fields = linkDataToFields(
        currentVendor,
        linkFields,
        null,
        extraFields
      );

      this.setState({ fields: fields });
    }
  }

  submit(e) {
    e.preventDefault();
    const { remove_vendor_contact_ids } = this.state;
    let result = validateFields(this.state.fields);
    if (result.check === false) {
      this.setState({
        fields: result.fields,
      });
    } else {
      const processedData = processFields(this.state.fields);
      const remove = remove_vendor_contact_ids.map((value) => (value.id));
      const id = path(['match', 'params', 'id'], this.props);
      this.props.saveForm(id, processedData, remove);
    }
    return false;
  }

  cancel() {
    this.props.redirectToVendors();
  }

  changeFormValue(field, newObject) {
    let stateClone = clone(this.state);

    if (typeof field === 'object') {
      // FIX: add support of multiple levels
      stateClone.fields[field[0]][field[2]] = newObject;
    } else {
      stateClone.fields[field] = newObject;
    }

    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  render() {
    const hasAccessForEdit = hasAccess({
      'permAreaKey': 'vendor',
      'permTypeKey': 'edit',
      'idForCheckingAuthor': path(['vendors', 'currentVendor', 'user_id'], this.props)
    });
    const disableFieldForEdit = !hasAccessForEdit;
    return (
      <div>
        <Breadcrumbs list={[
          { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
          { url: '/pages/vendors', icon: 'person_pin', name: 'Vendors' },
          { icon: 'edit', name: 'Vendors Edit' },
        ]} />
        <div className="card rounded">
          <div className="card-header rounded-top">
            <b>Edit Vendor</b>
          </div>
          <div className="card-block">
            <div className="col" style={{ paddingBottom: '40px' }}>
              <button className={'btn btn-danger btn-outline pull-right ml-3'} onClick={this.cancel}>
                <i className="fa fa-remove"></i>
                <span className="pl-1">Cancel</span>
              </button>
              {hasAccessForEdit &&
                <button className={'btn btn-success btn-outline pull-right'} onClick={this.submit}>
                  <i className="fa fa-check"></i>
                  <span className="pl-1">Save</span>
                </button>
              }
            </div>

            <form onSubmit={this.submit}>
              <div className="col-12">
                <Input
                  disabled={disableFieldForEdit}
                  field={this.state.fields['name']}
                  onChange={this.changeFormValue}
                />

                <DynamicFormList
                  disabled={disableFieldForEdit}
                  list={this.state.fields['contacts']}
                  onChange={this.changeFormValue}
                  fields={contacts}
                  idsForRemote={this.state.remove_vendor_contact_ids}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    redirectToVendors: () => {
      dispatch(push('/pages/vendors'));
    },
    getDataById: (id) => {
      getVendor(id)(dispatch);
    },
    saveForm: (id, data, remove) => {
      updateVendor(id, data, remove)(dispatch);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VendorEdit);



// WEBPACK FOOTER //
// ./src/containers/VendorEdit/index.js